/* eslint-disable react/jsx-max-props-per-line */

import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom'

import AdminPage from './admin'
import AdminRecordPatterns from './admin/admin-record-patterns'
import { AdminRecordsPage } from './admin/administrative-records/admin-records'
import { AuditLogPage } from './admin/audit/audit-log'
import { BehavioralHistoryPage } from './admin/audit/behavioral-health-history'
import { YouTurnHistoryPage } from './admin/audit/youturn-history'
import { ClientHistoryPage } from './admin/clients-and-organizations/client-history'
import { ClientsPage } from './admin/clients-and-organizations/clients'
import Configuration from './admin/configuration'
import IGAOAdmin from './admin/igao'
import { EnrollmentsPage } from './admin/mobile-management/enrollments'
import { MobileAttemptsPage } from './admin/mobile-management/mobile-attempts'
import { MobileHistoryPage } from './admin/mobile-management/mobile-history'
import { MobileUsersPage } from './admin/mobile-management/mobile-users'
import { SelfEnrollmentPage } from './admin/mobile-management/self-enrollment'
import Organizations from './admin/organizations'
import OrphanIGAO from './admin/orphan-igaos'
import Receivers from './admin/receivers'
import Settings from './admin/settings'
import Status from './admin/status'
import { UbaAuditLog } from './admin/uba/audit-log'
import { LucentRxScripts } from './admin/uba/lucent-rx-scripts'
import { UsersPage } from './admin/user-management/users'
import { AdvancedSearch } from './advanced-search'
import { Alerts } from './alerts'
import App from './App'
import { RequireAuth, RequireNoAuth } from './auth'
import { ChatsPage } from './chats'
import { DefaultClaimsTable } from './claim-history/default-table'
import Dashboard from './dashboard'
import EncounterHistory from './Encounter/EncountersHistory'
import EncounterSummary from './Encounter/EncounterSummary'
import GrandRounds from './Encounter/GrandRounds'
import { ErrorBoundary } from './error-boundary'
import { igaoPages } from './igao/utils'
import { Layout } from './layout'
import LoginForm from './LoginForm/LoginForm'
import { NewPatient } from './new-patient'
import { NotFound } from './NotFound'
import PatientFolder from './PatientFolder'
import Assessment from './PatientFolder/Assessment'
import { Behavioral } from './PatientFolder/behavioral'
import IGAO from './PatientFolder/IGAO'
import PatientFolderPatientFolder from './PatientFolder/PatientFolder'
import ReportRoot from './PatientFolder/Reports'
import Allergies from './PatientFolder/Standard/Allergies'
import { CSR } from './PatientFolder/Standard/CSR'
import Home from './PatientFolder/Standard/Demographics/Home'
import Insurance from './PatientFolder/Standard/Demographics/Insurance'
import MedicalDemographics from './PatientFolder/Standard/Demographics/Medical'
import NarusTeamDemographics from './PatientFolder/Standard/Demographics/NarusTeam'
import { PatientDemographics } from './PatientFolder/Standard/Demographics/Patient'
import SupportDemographics from './PatientFolder/Standard/Demographics/Support'
import Diagnostics from './PatientFolder/Standard/Diagnostics'
import DocumentsGrid from './PatientFolder/Standard/Documents'
import Choices from './PatientFolder/Standard/Goals/Choices'
import Expectations from './PatientFolder/Standard/Goals/Expectations'
import Goals from './PatientFolder/Standard/Goals/Goals'
import Maternity from './PatientFolder/Standard/maternity'
import MedicalDiagnosis from './PatientFolder/Standard/MedicalHistory/Diagnosis'
import Events from './PatientFolder/Standard/MedicalHistory/Events'
import Medications from './PatientFolder/Standard/Medications'
import PhysicalExam from './PatientFolder/Standard/PhysicalExam'
import Lifestyle from './PatientFolder/Standard/SocialHistory/Lifestyle'
import Resources from './PatientFolder/Standard/SocialHistory/Resources'
import Substance from './PatientFolder/Standard/SocialHistory/Substance'
import { Tribal } from './PatientFolder/Standard/SocialHistory/tribal'
import ESAS from './PatientFolder/Standard/Symptoms/ESAS'
import RoS from './PatientFolder/Standard/Symptoms/RoS'
import UtilizationExpense from './PatientFolder/Standard/UtilizationExpense'
import Vitals from './PatientFolder/Standard/Vitals'
import Profile from './Profile'
import { Tasks } from './tasks'
import Todos from './Todos'
import { Uba } from './uba'
import { CreateUserPage } from './uba/create-user'
import { EditUserPage } from './uba/edit-user'

let router = createBrowserRouter(createRoutesFromElements(
  <Route errorElement={<ErrorBoundary />}>
    <Route element={<RequireAuth />}>
      <Route path='' element={<Layout />}>
        <Route path='/' element={<App />}>
          <Route index element={<Dashboard />} />

          <Route path='admin' element={<AdminPage />}>
            <Route index element={<Navigate to='users' />} />
            <Route path='users' element={<UsersPage />} />
            <Route path='receivers' element={<Receivers />} />

            <Route path='organizations' element={<Organizations />} />
            <Route path='clients' element={<ClientsPage />} />
            <Route path='client-history' element={<ClientHistoryPage />} />

            <Route path='enrollments' element={<EnrollmentsPage />} />
            <Route path='mobile-users' element={<MobileUsersPage />} />
            <Route path='mobile-history' element={<MobileHistoryPage />} />
            <Route path='mobile-attempts' element={<MobileAttemptsPage />} />
            <Route path='self-enrollment' element={<SelfEnrollmentPage />} />

            <Route path='igao' element={<IGAOAdmin />} />
            {igaoPages.map(({ id }) => (
              <Route key={id} path={`igao/${id}`} element={<IGAOAdmin />} />
            ))}

            <Route path='orphan-igaos' element={<OrphanIGAO />} />
            <Route path='audit-log' element={<AuditLogPage />} />
            <Route path='uba-audit-log' element={<UbaAuditLog />} />
            <Route path='lucent-rx-scripts' element={<LucentRxScripts />} />

            {/* TODO: this is not working */}
            <Route path='status' element={<Status />} />
            <Route path='behavioral' element={<BehavioralHistoryPage />} />
            <Route path='youturn' element={<YouTurnHistoryPage />} />

            <Route path='admin-records' element={<AdminRecordsPage />} />
            <Route path='admin-record-patterns' element={<AdminRecordPatterns />} />

            <Route path='settings' element={<Settings />} />
            <Route path='config' element={<Configuration />} />
          </Route>

          <Route path='new-patient' element={<NewPatient />} />
          <Route path='alerts' element={<Alerts />} />
          <Route path='tasks' element={<Todos />} />
          <Route path='tasks-new' element={<Tasks />} />
          <Route path='profile' element={<Profile />} />
          <Route path='chats' element={<ChatsPage />} />
          <Route path='patient-search' element={<AdvancedSearch />} />

          <Route path='patient/:clientName/:id' element={<PatientFolder />}>
            <Route index element={<Navigate to='patientFolder' />} />
            <Route path='patientFolder' element={<PatientFolderPatientFolder />} />
            <Route path='report/:reportId/:reportType' element={<ReportRoot />} />

            <Route path='assessment' element={<Assessment />}>
              <Route index element={<Navigate to='igao' />} />
              <Route path='igao' element={<IGAO />} />
              <Route path='claims-history' element={<DefaultClaimsTable />} />
              <Route path='standarddemographicspatient' element={<PatientDemographics />} />
              <Route path='standarddemographicsinsurance' element={<Insurance />} />
              <Route path='standarddemographicshomeassessment' element={<Home />} />
              <Route path='standardsocialhistorytribal' element={<Tribal />} />
              <Route path='standardcsr' element={<CSR />} />
              <Route path='standarddemographicssupport' element={<SupportDemographics />} />
              <Route path='standarddemographicsmedical' element={<MedicalDemographics />} />
              <Route path='standarddemographicsnarusteam' element={<NarusTeamDemographics />} />
              <Route path='standardmedicaldiagnosis' element={<MedicalDiagnosis />} />
              <Route path='standardmaternity' element={<Maternity />} />
              <Route path='standardmedicaldocuments' element={<DocumentsGrid />} />
              <Route path='standardmedicalevents' element={<Events />} />
              <Route path='standardsocialhistorylifestyle' element={<Lifestyle />} />
              <Route path='standardsocialhistoryresources' element={<Resources />} />
              <Route path='standardsocialhistorysubstance' element={<Substance />} />
              <Route path='standardallergies' element={<Allergies />} />
              {/* <Route path='standardbehavioral' element={<BehavioralHealthPage />} /> */}
              <Route path='standardbehavioral' element={<Behavioral />} />
              <Route path='standardmedications' element={<Medications />} />
              <Route path='standardvitals' element={<Vitals />} />
              <Route path='standardsymptomsesas' element={<ESAS />} />
              <Route path='standardsymptomsros' element={<RoS />} />
              <Route path='standardpeexam' element={<PhysicalExam />} />
              <Route path='standarddiagnostics' element={<Diagnostics />} />
              <Route path='standardgoals' element={<Goals />} />
              <Route path='utilizationexpense' element={<UtilizationExpense />} />
              <Route path='standardexpectations' element={<Expectations />} />
              <Route path='standardgoalschoices' element={<Choices />} />
              <Route path='encountersummary' element={<EncounterSummary />} />
              <Route path='encounterhistory' element={<EncounterHistory />} />
              <Route path='grandrounds' element={<GrandRounds />} />
              <Route path='standarddocuments' element={<DocumentsGrid />} />
              <Route path='uba' element={<Uba />} />
              <Route path='uba/new-user' element={<CreateUserPage />} />
              <Route path='uba/edit-user' element={<EditUserPage />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>

    <Route element={<RequireNoAuth />}>
      <Route path='/login' element={<LoginForm />} />
    </Route>

    <Route path='*' element={<NotFound />} />
  </Route>
))

export function Router (): JSX.Element {
  return (
    <RouterProvider router={router} />
  )
}

// @ts-expect-error // It's fine
if (import.meta.hot) {
  // @ts-expect-error // It's fine, too
  import.meta.hot.dispose(() => router.dispose())
}
